import React, { useState, useEffect, useContext } from "react";
import Style from "./index.module.css";
import { useLocation } from "react-router-dom";
import Breadcrumb from "../../../Components/Breadcrumb/Breadcrumb";
import Navbar from "../../../Components/Navbar/Navbar";
import Footer from "../../../Components/Footer/Footer";
import OwnCard from "../../../Components/Cards/OwnProductCard/OwnCard";
import authInstance from "../../../instance/AuthInstance";
import { UserContext } from "../../../Contexts/UserContext";
import AddCard from "../../../Components/Cards/AddCards/AddCards";
import { useTranslation } from "react-i18next";
import { FaRocket } from "react-icons/fa";
import { toast } from "react-toastify";

const OwnProductPage = () => {
  const { t } = useTranslation()
  const location = useLocation();
  const pathSegment = location.pathname.split("/").filter((segment) => segment);

  const LoggedInUser = useContext(UserContext);
  const { User } = LoggedInUser;

  const [UserProducts, SetUserProducts] = useState([]);
  const [Reload, SetReload] = useState(false);
  const [boostStats, setBoostStats] = useState({
    boostsRemaining: 0,
    maxBoosts: 0,
    usedBoosts: 0,
    planName: ''
  });

  const loadUserProducts = () => {
    try {
      authInstance
        .get(`/api/super_admin/product_control/get_userproducts/${User._id}`)
        .then((response) => {
          SetUserProducts(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBoostStats = async () => {
    try {
      const response = await authInstance.get(
        `/api/user/product/get_boost_count/${User._id}`
      );
      if (response.data) {
        setBoostStats(response.data);
      }
    } catch (error) {
      console.error("Error fetching boost stats:", error);
    }
  };

  const handleBoost = async (adId) => {
    if (boostStats.boostsRemaining <= 0) {
      toast.error("You have used all your boosts for this month!");
      return;
    }

    try {
      const response = await authInstance.put(`/api/user/product/boost/${adId}`);

      if (response.data?.success) {
        toast.success("Product boosted successfully! 🚀");
        reloadProducts(); // Reload to update list
        fetchBoostStats(); // Reload stats
      }
    } catch (error) {
      console.error("Error boosting product:", error);
      toast.error(error.response?.data?.message || "Failed to boost product");
    }
  };

  // Function to toggle reload state
  const reloadProducts = () => {
    SetReload((prevState) => !prevState);
  };

  //Load Product functions
  useEffect(() => {
    if (User?._id) {
      loadUserProducts();
      fetchBoostStats();
    }
  }, [Reload, User]);

  function ScrollToTopOnMount() {
    window.scrollTo(0, 0);
    return null;
  }

  useEffect(() => {
    ScrollToTopOnMount();
  }, []);
  return (
    <div className={Style.page_wrapper}>
      <ScrollToTopOnMount />
      <Navbar />
      <div className={Style.main}>
        <Breadcrumb pathSegments={pathSegment} />
        <div className={Style.productwrapper}>
          <div className={Style.container}>
            <div className={Style.heading}>
              <div className={Style.left}>
                <h2 className={Style.head}>{t("own_ads")}</h2>
              </div>
              <div className={Style.right}>
                {/* Boost Counter Badge */}
                {boostStats.planName !== 'Free Plan' && (
                  <div className={Style.boostCounter}>
                    <div className={Style.couterIcon}>
                      <FaRocket />
                    </div>
                    <div className={Style.counterInfo}>
                      <span className={Style.counterLabel}>{boostStats.planName}</span>
                      <span className={Style.counterValue}>
                        {boostStats.boostsRemaining} / {boostStats.maxBoosts} Boosts
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={Style.cardWrapper}>
              {UserProducts.map((product, index) => {
                if (product.type === "advertisement") {
                  return <AddCard key={index} properties={product} />
                }
                return (
                  <OwnCard
                    key={index}
                    product={product}
                    reloadProducts={reloadProducts}
                    boostStats={boostStats}
                    handleBoost={handleBoost}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default OwnProductPage;
